// @ts-ignore
import {ApiValidation} from '../../model/api/api-validation';
import {TableRecordResult} from '../../model/api/table-record-result';
import {CrystalclearBackUrl} from './crystalclear-back-url';
import {ScheduleProfile} from '../../model/tools/schedule-profile';
import {ServiceHealthState} from "../../model/tools/service-health-state";

export class CrystalclearToolsBackUrl {
  //SCHEDULER
  static readonly GET_SCHEDULER_PROFILE_LIST: CrystalclearBackUrl.UrlConf<TableRecordResult<ScheduleProfile>> = {
    url: '/api/tools/scheduler/list',
    type: TableRecordResult
  };

  static readonly SAVE_SCHEDULER_PROFILE: CrystalclearBackUrl.UrlConf<ApiValidation<ScheduleProfile>> = {
    url: '/api/tools/scheduler/save',
    type: ApiValidation
  };

  static readonly DELETE_SCHEDULER_PROFILE: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/tools/scheduler/delete',
    type: ApiValidation
  };

  static readonly EXECUTE_SCHEDULER_PROFILE: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/tools/scheduler/execute',
    type: ApiValidation
  };

  static readonly REFRESH_SCHEDULER_PROFILE: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/tools/scheduler/refresh',
    type: ApiValidation
  };

  static readonly LOADSETTINGS_SCHEDULER_PROFILE: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/tools/scheduler/loadsettings',
    type: ApiValidation
  };

  static readonly SAVESETTINGS_SCHEDULER_PROFILE: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/tools/scheduler/savesettings',
    type: ApiValidation
  };

  //HEALTH
  static readonly GET_SERVICES_HEALTH: CrystalclearBackUrl.UrlConf<ApiValidation<ServiceHealthState[]>> = {
    url: '/api/health/services',
    type: ApiValidation
  };

}
